import dayjs from '../../../../config/dayjs';
import { getSampleCenterFields } from './dashboardPlaceholders';

// A center is one exam hall on one server for one exam (same grouping as ExamSummary).
// Counts come from the center-summary API (computed in SQL); here we only add display fields.
export const buildCenters = (data) => {
    const exams = data?.exams ?? [];

    const centers = (data?.centers ?? []).map((center) => {
        const exam = exams.find((e) => e.id === center.projectMasterId);
        return {
            ...center,
            key: `${center.projectMasterId}-${center.serverId}-${center.examHallId}`,
            examName: exam ? `${exam?.['course.courseName'] ?? ''} / ${exam?.['batch.batchName'] ?? ''}` : '',
            firstLogin: center.firstLogin ? dayjs.utc(center.firstLogin) : null,
            lastLogin: center.lastLogin ? dayjs.utc(center.lastLogin) : null,
        };
    });

    // Sample values for data central does not have yet (shown lighter in the UI)
    return centers.map((center, index) => ({ ...center, ...getSampleCenterFields(center, index) }));
}

// "Summary by Centers": how many centers have finished each step.
// Biometric upload is not on central yet, so that ring uses sample data (isSample).
export const buildCenterRings = (centers) => {
    const done = (fn) => centers.filter(fn).length;
    return [
        { title: 'Candidate download', done: done((c) => c.candidatesDataDownloaded) },
        { title: 'QP download', done: done((c) => c.qPacksDownloaded) },
        // Every candidate who logged in has a captured biometric
        { title: 'Biometric', done: done((c) => c.present > 0 && c.biometricCaptured >= c.present) },
        { title: 'Exam login', done: done((c) => c.present > 0) },
        { title: 'Rpack upload', done: done((c) => c.serverRPacksUploaded) },
        { title: 'Biometric upload', done: done((c) => c.present > 0 && c.biometricUploaded >= c.present), isSample: true },
        { title: 'Log upload', done: done((c) => c.serverAuditLogsUploaded) },
    ].map((ring) => ({ ...ring, total: centers.length }));
}
